import {Component, EventEmitter, Input, Optional, Output, ViewChild} from '@angular/core';
import {BimDataModel, BimModelService, FileUploadComponent} from '@cas-hub/acabim-common-client';
import {NGXLogger} from 'ngx-logger';

const enum FileProcessingState {
    pending = 0,
    uploading = 1,
    processing = 2
}

@Component({
    selector: 'acabim-admin-update-bim-model',
    templateUrl: './update-bim-model.component.html',
    styleUrls: ['./update-bim-model.component.scss']
})
export class UpdateBimModelComponent {

    @Input() public model?: BimDataModel;
    @Output() closeDialog = new EventEmitter<boolean>();

    @ViewChild('ifcFileUpload', {static: false}) public ifcFileUpload?: FileUploadComponent;

    public get modelName(): string {
        return this.model?.modelName ?? this.model?.modelId ?? 'Unknown';
    }

    public currentUploadProgress = 0;
    public currentState = FileProcessingState.pending;


    constructor(private readonly bimModelService: BimModelService,
                @Optional() private readonly logger?: NGXLogger) {
    }

    public updateModel(): void {
        const file = this.ifcFileUpload?.file;
        if (file && this.model) {
            this.currentState = FileProcessingState.uploading;
            this.bimModelService.updateBimModel(this.model.modelId, file, () => {
                this.logger?.debug('[UpdateBimModelComponent] Update BIM Model completed');
                this.currentState = FileProcessingState.pending;
                this.closeDialog.emit(true);
            }).subscribe(progress => {
                if (progress > 99) {
                    this.currentState = FileProcessingState.processing;
                } else {
                    this.currentUploadProgress = progress;
                }
            });
        } else {
            this.logger?.debug('[UpdateBimModelComponent] Either file or model is missing - Unable to update');
        }
    }
}
